import { FaHome } from "react-icons/fa";
import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <div className="hero">
      <div className="text-center hero-content">
        <div className="max-w-lg">
          <h1 className="text-8xl font-bold mb-8">Hmm.</h1>
          <p className="text-5xl mb-8">Going somewhere you shouldn't?</p>
          <Link to="/" className="btn btn-primary btn-lg">
            <FaHome className="mr-2" />
            Home.
          </Link>
        </div>
      </div>
    </div>
  );
};
